/*
 * nf-cart.js — apoio ao carrinho em drawer (Fase 5).
 * -------------------------------------------------------------------
 * Unica responsabilidade hoje: sincronizar a visibilidade do WhatsApp
 * float (section-whatsapp-float.css) com o estado do drawer e com a
 * pagina /cart. A regra principal e CSS puro via :has() — este script e
 * o fallback para navegadores sem suporte e cobre a corrida inicial de
 * carregamento. Efeito: adiciona/remove `.nf-whatsapp-float--hidden` no
 * botao flutuante.
 */
(function () {
  if (window.nfCartLoaded) return;
  window.nfCartLoaded = true;

  function syncWhatsappVisibility() {
    var whatsapp = document.querySelector('.whatsapp-float');
    if (!whatsapp) return;

    var isCartPage = !!document.querySelector('main[data-template="cart"]');
    var drawer = document.querySelector('cart-drawer');
    var drawerOpen = !!(drawer && drawer.classList.contains('active'));

    whatsapp.classList.toggle('nf-whatsapp-float--hidden', isCartPage || drawerOpen);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncWhatsappVisibility();

    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(syncWhatsappVisibility).observe(drawer, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  });
})();
